module.exports = __webpack_public_path__ + "tugo-transit-institution-tooltip.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/tugo/tugo-transit-institution-tooltip.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/tugo/tugo-transit-institution-tooltip.png
// module chunks = 15